import { lazy } from 'react';

export const AddEquipmentLazy = lazy(() => import('./AddEquipment'));
